import { ApolloLink, Observable } from '@apollo/client';
import { RetryLink } from '@apollo/client/link/retry';

// Opt-in per operation via `context: { retry: true, timeoutMs }`, so mutations
// are never replayed or abandoned mid-flight by default.

// 4xx (WAF, rate limit) won't succeed on retry.
export const retryLink = new RetryLink({
  delay: { initial: 500, max: 3000, jitter: true },
  attempts: {
    max: 3,
    retryIf: (error, operation) =>
      operation.getContext().retry === true &&
      (!error?.statusCode || error.statusCode >= 500),
  },
});

// fetch has no timeout, so a hung request would spin forever. Sits after the
// retry link so each attempt gets its own timer; unsubscribing aborts the fetch.
export const timeoutLink = new ApolloLink((operation, forward) => {
  const { timeoutMs } = operation.getContext();
  if (!timeoutMs) return forward(operation);

  return new Observable(observer => {
    const subscription = forward(operation).subscribe(observer);
    const timer = setTimeout(() => {
      subscription.unsubscribe();
      const error = new Error('Request timed out');
      // Tells a timeout apart from other network errors in RUM.
      error.name = 'TimeoutError';
      observer.error(error);
    }, timeoutMs);

    return () => {
      clearTimeout(timer);
      subscription.unsubscribe();
    };
  });
});
